module.exports = __webpack_public_path__ + "static/Moonlighter5-b8ac55bc2e71cb94912a90cc40018c9c.webp";